enum FileReaderFormatEnum {
	buffer = 'buffer',
	binaryString = 'binaryString',
	dataURL = 'dataURL',
	text = 'text'
}
export default FileReaderFormatEnum;
